import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { getStoredValue } from "../_helpers/storagehelper";

const initialDNDSearch = {
  InviteThrough: "Both",
  InviteThroughValue: 0,
  ContactNumberOrEmail: "",
  dndType: "Both",
  dndTypeValue: 0,
  IsActive: 2,
  Remarks: "",
  pageNo: 1,
  rowCountPerPage: 10,
  exportExcel: false,
  SortBy: "",
};

const initialDNDData = {};

// create slice
const name = "DND";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const dndAction = { ...slice.actions, ...extraActions };
export const DNDReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    DNDSearchdata: initialDNDSearch,
    DNDData: initialDNDData,
    getUserDNDList: {},
    getTwilioDNDList: {},
    getUserExcelDNDList:{},
    getTwilioExcelDNDList: {},
    loading: false,
    createDNDUser: {},
    GetPublicUserDNDInfo: {},
    updateTwilioDND: {},
  };
}

function createReducers() {
  return {
    resetForm,
    setDNDSearch,
    clearDNDSearch,
    clearGetTwilioExcelDNDList,
    clearGetUserExcelDNDList,
  };

  function resetForm(state) {
    state.DNDData = initialDNDData;
    state.createDNDUser = {};
  }

  function setDNDSearch(state, action) {
    state.DNDSearchdata = action && action.payload;
  }

  function clearDNDSearch(state) {
    state.DNDSearchdata = initialDNDSearch;
  }
  function clearGetTwilioExcelDNDList(state) {
    state.getTwilioExcelDNDList = {};
  }
  function clearGetUserExcelDNDList(state) {
    state.getUserExcelDNDList = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser`;
  return {
    getUserDNDList: getUserDNDList(),
    getTwilioDNDList: getTwilioDNDList(),
    updateTwilioDND: updateTwilioDND(),
    createDNDUser: createDNDUser(),
    GetPublicUserDNDInfo: GetPublicUserDNDInfo(),
    UpdateDND: UpdateDND(),
  };

  function getUserDNDList() {
    return createAsyncThunk(
      `${name}/LoadPublicUserDNDList`,
      async (DNDData) =>
        await fetchWrapper.post(`${baseUrl}/DND/LoadPublicUserDNDList`, DNDData)
    );
  }

  function getTwilioDNDList() {
    return createAsyncThunk(
      `${name}/LoadTwilioDNDList`,
      async (DNDData) =>
        await fetchWrapper.post(`${baseUrl}/DND/LoadTwilioDNDList`, DNDData)
    );
  }

  function updateTwilioDND() {
    const createdBy = getStoredValue("user")?.ManagementUserID;

    return createAsyncThunk(
      `${name}/updateTwilioDND`,
      async () =>
        await fetchWrapper.post(
          `${baseUrl}/DND/UpdateTwilioDND?CreatedBy=${createdBy}`
        )
    );
  }

  function createDNDUser() {
    return createAsyncThunk(
      `${name}/AddDND`,
      async (data) => await fetchWrapper.post(`${baseUrl}/DND/AddDND`, data)
    );
  }

  function GetPublicUserDNDInfo() {
    return createAsyncThunk(
      `${name}/GetPublicUserDNDInfo`,
      async (id) =>
        await fetchWrapper.get(
          `${baseUrl}/DND/GetPublicUserDNDInfo?PublicUserDNDListID=${id}`
        )
    );
  }

  function UpdateDND() {
    return createAsyncThunk(
      `${name}/UpdateDND`,
      async (data) => await fetchWrapper.post(`${baseUrl}/DND/UpdateDND`, data)
    );
  }
}

function createExtraReducers(builder) {
  builder
    //DND User list
    .addCase(extraActions.getUserDNDList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getUserDNDList.fulfilled, (state, action) => {
         let params = action.meta.arg;
         if (params?.exportExcel) {
           state.getUserExcelDNDList = action.payload;
         } else {
           state.getUserDNDList = action.payload;
         }

         state.loading = false;
         state.error = null;
    })
    .addCase(extraActions.getUserDNDList.rejected, (state, action) => {
      state.getUserDNDList.loading = false;
      state.error = action.error.message || "Failed to add DND List";
    })
    //Twilio DND User list
    .addCase(extraActions.getTwilioDNDList.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getTwilioDNDList.fulfilled, (state, action) => {
      let params = action.meta.arg;
      if (params?.exportExcel) {
        state.getTwilioExcelDNDList = action.payload;
      } else {
        state.getTwilioDNDList = action.payload;
      }

      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.getTwilioDNDList.rejected, (state, action) => {
      state.getTwilioDNDList.loading = false;
      state.error = action.error.message || "Failed to add DND List";
    })
    //create DND
    .addCase(extraActions.createDNDUser.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.createDNDUser.fulfilled, (state, action) => {
      state.loading = false;
      state.createDNDUser = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.createDNDUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add DND List";
    })
    //User List by ID
    .addCase(extraActions.GetPublicUserDNDInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetPublicUserDNDInfo.fulfilled, (state, action) => {
      state.loading = false;
      state.GetPublicUserDNDInfo = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.GetPublicUserDNDInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add DND List";
    })
    //update DND User
    .addCase(extraActions.UpdateDND.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.UpdateDND.fulfilled, (state, action) => {
      state.loading = false;
      state.createDNDUser = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.UpdateDND.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to add DND List";
    })
    //update TWILIO
    .addCase(extraActions.updateTwilioDND.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateTwilioDND.fulfilled, (state, action) => {
      state.loading = false;
      state.updateTwilioDND = action?.payload;
      state.error = null;
    })
    .addCase(extraActions.updateTwilioDND.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to Update Twilio DND";
    });
}
